export interface StaticText {
  key: string;
  value: string;
}

export interface ComponentInfo {
  staticTextList: Array<StaticText>;
}

export enum StaticTextType {
  risks_text = 'risks_text',
  site_description = 'site_description',
}
